<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Secondary Valve Package</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (connectionSizeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Connection Size:</label>
            <select class="halfWidthInputField" #connectionSizeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(connectionSizeSelection.Name)"
              (change)="selectionChanged(connectionSizeSelection, connectionSizeInput.value)"
              [value]="connectionSizeSelection.Value.toString()">
              @for (allowable of connectionSizeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="connectionSizeSelection.Value && connectionSizeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (motorizedControlValveSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Control Valve:</label>
            <select class="halfWidthInputField" #controlValveInput
              [class.invalidConfigurationSelection]="isInvalidSelection(motorizedControlValveSelection.Name)"
              (change)="selectionChanged(motorizedControlValveSelection, controlValveInput.value)"
              [value]="motorizedControlValveSelection.Value.toString()">
              @for (allowable of motorizedControlValveSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="motorizedControlValveSelection.Value && motorizedControlValveSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (riserConnectionSupplySelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Riser Connection - Supply:</label>
            <select class="halfWidthInputField" #riserConnectionSupplyInput
              [class.invalidConfigurationSelection]="isInvalidSelection(riserConnectionSupplySelection.Name)"
              (change)="selectionChanged(riserConnectionSupplySelection, riserConnectionSupplyInput.value)"
              [value]="riserConnectionSupplySelection.Value.toString()">
              @for (allowable of riserConnectionSupplySelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="riserConnectionSupplySelection.Value && riserConnectionSupplySelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (riserConnectionReturnSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Riser Connection - Return:</label>
            <select class="halfWidthInputField" #riserConnectionReturnInput
              [class.invalidConfigurationSelection]="isInvalidSelection(riserConnectionReturnSelection.Name)"
              (change)="selectionChanged(riserConnectionReturnSelection, riserConnectionReturnInput.value)"
              [value]="riserConnectionReturnSelection.Value.toString()">
              @for (allowable of riserConnectionReturnSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="riserConnectionReturnSelection.Value && riserConnectionReturnSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (flowControlSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Flow Control:</label>
            <select class="halfWidthInputField" #flowControlInput
              [class.invalidConfigurationSelection]="isInvalidSelection(flowControlSelection.Name)"
              (change)="selectionChanged(flowControlSelection, flowControlInput.value)"
              [value]="flowControlSelection.Value.toString()">
              @for (allowable of flowControlSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="flowControlSelection.Value && flowControlSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (normallyOpenSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(normallyOpenSelection.Name)"
            for="secondaryNormallyOpenInput" class="halfWidthInputLabel">Normally Open:</label>
            <input type="checkbox" id="secondaryNormallyOpenInput" #secondaryNormallyOpenInput
              [checked]="'true' === normallyOpenSelection.Value" class="checkboxInput"
              (change)="selectionChanged(normallyOpenSelection, secondaryNormallyOpenInput.checked.toString())">
          </span>
        }
      </div>
    </div>
  }
</div>
